<template>
  <div class="base-color-picker">
    <label v-if="label" class="form-label">
      {{ label }}
      <span v-if="required" class="text-danger">*</span>
    </label>

    <div class="picker-wrapper">
      <ColorPicker
          v-model:pureColor="color"
          format="hex"/>

<!--      <div-->
<!--          class="color-preview"-->
<!--          :style="{ backgroundColor: color }">-->
<!--      </div>-->

<!--      <span class="color-value">{{ color }}</span>-->
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue"
import { ColorPicker } from "vue3-colorpicker"
import "vue3-colorpicker/style.css"
import { defineEmits, defineProps } from 'vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: "#000000"
  },
  label: {
    type: String,
    default: ""
  },
  required: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(["update:modelValue"])

const color = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value)
})
</script>

<style scoped>
.base-color-picker {
  display: flex;
  flex-direction: column;
}

.rounded-picker :deep(.vc-color-wrap .current-color) {
  border-radius: 3px;
}

.picker-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.color-preview {
  width: 30px;
  height: 30px;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.color-value {
  font-size: 13px;
  color: #666;
}
</style>